export default "__VITE_ASSET__b2a328f1__"